import React from "react";
import Contact from "../../../components/Contact.js";
import GetInTouch from "../../../components/GetInTouch.js";
import ProcessFollow from "../../../components/ProcessFollow.js";

const MobileAppDev = () => {
  const scrollToContact = () => {
    const contactSection = document.getElementById("contact-section");
    contactSection.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <div className=" flex flex-col items-center justify-center mt-20 p-6">
      <div className=" rounded-lg p-4 lg:text-center md:text-center max-w-5xl  mb-20">
        <h1 className=" text-2xl  md:text-4xl lg:text-6xl font-bold mb-4 mt-6">
          Custom Mobile App Development Services
        </h1>
        <p className="text-lg text-gray-700 mb-2">
          We specialize in creating innovative and user-friendly mobile
          applications that cater to your business needs. From ideation to
          deployment, our team ensures seamless delivery of solutions that
          provide an exceptional user experience and drive business growth.
        </p>
        <button
          onClick={() =>
            window.scrollTo({ top: window.innerHeight, behavior: "smooth" })
          }
          className="mt-20 mb-10  px-6 py-3 rounded-full bg-green-600 text-white hover:bg-yellow-500 hover:text-green-700 hover:border hover:border-yellow-500"
        >
          Scroll Down
        </button>
      </div>

      <div className=" py-5 px-5 w-full">
        <div className="flex flex-col lg:flex-row items-center lg:space-x-16">
          <div className="flex justify-center lg:w-1/4 mb-12 lg:mb-0">
            <img
              src="/assets/images/webAppDev/mob1.avif"
              alt="Mobile App Solutions"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>

          <div className="lg:w-3/4 lg:text-left">
            <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
              Leading Mobile App Development Company
            </h2>
            <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 leading-relaxed mb-3">
              Empower your business with cutting-edge mobile applications
              tailored to your specific needs. At Ayanshtech, we offer
              end-to-end mobile app development services, ensuring every project
              is delivered with precision, quality, and a deep focus on user
              satisfaction.
              <br />
              <br />
              Our expertise spans across diverse industries and platforms,
              including iOS, Android, and cross-platform solutions. Whether
              you're a startup or a global enterprise, we craft applications
              that align with your vision and business objectives.
            </p>
          </div>
        </div>
      </div>

      <div className=" ">
        <div className="">
          <div className="text-center mt-10 mb-4 p-6">
            <h2 className="font-bold text-gray-800 mb-2 sm:text-3xl md:text-4xl lg:text-6xl">
              Technology Expertise
            </h2>
          </div>
          <div className="flex justify-center">
            <div className="overflow-hidden max-w-7xl">
              <div className="flex animate-scroll-left gap-6">
                <div className="flex-shrink-0">
                  <img
                    src="/assets/images/techStack/nodeJs.svg"
                    alt="Angular Js"
                    className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                  />
                </div>
                <div className="flex-shrink-0">
                  <img
                    src="/assets/images/techStack/angularJs.svg"
                    alt="AngularJs"
                    className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                  />
                </div>
                <div className="flex-shrink-0">
                  <img
                    src="/assets/images/techStack/laravel.png"
                    alt="Laravel"
                    className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                  />
                </div>
                <div className="flex-shrink-0">
                  <img
                    src="/assets/images/techStack/flutter.svg"
                    alt="Flutter"
                    className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                  />
                </div>
                <div className="flex-shrink-0">
                  <img
                    src="/assets/images/techStack/kotlin.svg"
                    alt="Kotlin"
                    className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                  />
                </div>

                <div className="flex-shrink-0">
                  <img
                    src="/assets/images/techStack/magento.svg"
                    alt="Magento"
                    className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                  />
                </div>
                <div className="flex-shrink-0">
                  <img
                    src="/assets/images/techStack/mongoDb.svg"
                    alt="mongoDB"
                    className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                  />
                </div>
                <div className="flex-shrink-0">
                  <img
                    src="/assets/images/techStack/mySql.svg"
                    alt="mysql"
                    className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                  />
                </div>
                <div className="flex-shrink-0">
                  <img
                    src="/assets/images/techStack/nextJs.svg"
                    alt="Laravel"
                    className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                  />
                </div>
                <div className="flex-shrink-0">
                  <img
                    src="/assets/images/techStack/php.svg"
                    alt="Mern Stack"
                    className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                  />
                </div>
                <div className="flex-shrink-0">
                  <img
                    src="/assets/images/techStack/postgreSql.svg"
                    alt="Mern Stack"
                    className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                  />
                </div>
                <div className="flex-shrink-0">
                  <img
                    src="/assets/images/techStack/react.svg"
                    alt="Mern Stack"
                    className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                  />
                </div>
                <div className="flex-shrink-0">
                  <img
                    src="/assets/images/techStack/swift.svg"
                    alt="Mern Stack"
                    className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                  />
                </div>

                <div className="flex-shrink-0">
                  <img
                    src="/assets/images/techStack/vite.svg"
                    alt="Mern Stack"
                    className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                  />
                </div>
                <div className="flex-shrink-0">
                  <img
                    src="/assets/images/techStack/vueJs.svg"
                    alt="Mern Stack"
                    className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                  />
                </div>
                <div className="flex-shrink-0">
                  <img
                    src="/assets/images/techStack/wordPress.svg"
                    alt="Mern Stack"
                    className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full max-w-7xl bg-blue-800 text-white  rounded-3xl mt-10 mx-auto p-6">
        <div className=" mx-auto text-center flex justify-center md:justify-between items-center">
          <h2 className="text-xl md:text-2xl lg:text-3xl  ">
            Transform Your Business with a Custom Mobile App Today!
          </h2>
          <button
            onClick={scrollToContact}
            className="bg-green-500 px-4 py-2 ml-6 rounded-full "
          >
            Get Started
          </button>
        </div>
      </div>

      <div className="text-center mt-10">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Benefits of Choosing Our Mobile App Development Services
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 mt-4 max-w-6xl mx-auto">
          At Ayanshtech, we focus on delivering mobile applications that are not
          just functional but also provide an unmatched user experience. Our
          team ensures best practices are followed throughout the development
          process.
        </p>
      </div>

      <div className=" p-4">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="w-full md:w-1/3 p-4">
            <img
              src="/assets/images/webAppDev/mob2.avif"
              alt="Click to Call Benefits"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>

          <div className="md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon1.png"
                alt="Custom App Development"
                className="w-10 h-10"
              />
              <p className="text-lg">
                Build custom mobile applications tailored to your business
                needs.
              </p>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon2.png"
                alt="Cross-Platform Compatibility"
                className="w-10 h-10"
              />
              <p className="text-lg">
                Develop apps that work seamlessly across multiple platforms,
                such as iOS and Android.
              </p>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon3.png"
                alt="User-Friendly Design"
                className="w-10 h-10"
              />
              <p className="text-lg">
                Enhance user engagement with intuitive and easy-to-use app
                interfaces.
              </p>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon4.png"
                alt="Scalable Solutions"
                className="w-10 h-10"
              />
              <p className="text-lg">
                Create scalable mobile applications that grow with your business
                needs.
              </p>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon5.png"
                alt="Integration with Backend Systems"
                className="w-10 h-10"
              />
              <p className="text-lg">
                Easily integrate mobile apps with existing backend systems and
                databases.
              </p>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon6.png"
                alt="Post-Launch Support"
                className="w-10 h-10"
              />
              <p className="text-lg">
                Provide ongoing support and maintenance to keep your mobile app
                up-to-date.
              </p>
            </div>
          </div>
        </div>
      </div>

      <ProcessFollow />

      <div id="contact-section">
        <Contact />
      </div>

      <GetInTouch />
    </div>
  );
};

export default MobileAppDev;
